import { jsx } from "react/jsx-runtime";
import { forwardRef, useEffect, useImperativeHandle, useRef } from "react";
import { useElementSize } from "../../hooks/index.js";
import { FitBox } from "./components/FitBox.js";
import { GreedyBox } from "./components/GreedyBox.js";
import { Scroller } from "./components/Scroller.js";
import { useOnHorizontalVisibilityChange } from "./hooks/useOnHorizontalVisibilityChange.js";
import { useOnScroll } from "./hooks/useOnScroll.js";
import { useOnSizeChange } from "./hooks/useOnSizeChange.js";
import { useOnVerticalVisibilityChange } from "./hooks/useOnVerticalVisibilityChange.js";
import { useScrollbarApi } from "./hooks/useScrollbarApi.js";
const Scrollbar = forwardRef((props, ref) => {
  const {
    testId = "scrollbar-root",
    onReady,
    children,
    onScroll,
    hideOverflow,
    onSizeChange,
    onVerticalVisibilityChange,
    onHorizontalVisibilityChange
  } = props;
  const fitBoxRef = useRef(null);
  const scrollbarRef = useRef(null);
  const size = useElementSize(fitBoxRef.current);
  const scrollbarApi = useScrollbarApi(scrollbarRef.current);
  useImperativeHandle(ref, () => scrollbarApi, [scrollbarApi]);
  useEffect(() => {
    if (!scrollbarApi) return;
    onReady?.(scrollbarApi);
  }, [onReady, scrollbarApi]);
  useOnSizeChange(size, onSizeChange);
  useOnScroll(scrollbarRef.current, onScroll);
  useOnHorizontalVisibilityChange(scrollbarRef.current, onHorizontalVisibilityChange);
  useOnVerticalVisibilityChange(scrollbarRef.current, onVerticalVisibilityChange);
  return /* @__PURE__ */ jsx(GreedyBox, { "data-testid": testId, "data-tidal": "Scrollbar", children: /* @__PURE__ */ jsx(FitBox, { ref: fitBoxRef, children: /* @__PURE__ */ jsx(
    Scroller,
    {
      "data-testid": "scroller",
      hideOverflow,
      ref: scrollbarRef,
      style: {
        height: size.height,
        width: size.width
      },
      children
    }
  ) }) });
});
export {
  Scrollbar
};
//# sourceMappingURL=Scrollbar.js.map
